import { render, staticRenderFns } from "./LinhaPrincipal.vue?vue&type=template&id=377618d3&"
import script from "./LinhaPrincipal.vue?vue&type=script&lang=js&"
export * from "./LinhaPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports